import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.alabaster,
  fontColor: colors.ash,
  textColorDark: colors.ash,
  textColorLight: colors.white
};
export default promoBanner;